<!--
 * @Autor: Hongting Yuan
 * @Date: 2021-12-08 21:04:13
 * @LastEditors: Haiting Zhao
 * @LastEditTime: 2021-12-19 13:07:26
 * @Description: file content
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front\src\views\scientificachieve\RewardAchieve.vue
-->

<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name:'WorkPlace' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科研成果</el-breadcrumb-item>
      <el-breadcrumb-item>获奖成果</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card
      style="width: 100%;height: 100%"
    >
      <!-- 根据用户名搜索 -->
      <el-input v-model="userName" style="margin-bottom: 15px;width: 260px; height: 40px;margin-right: 50px;" placeholder="请输入负责人名字" clearable @clear="getrewardAchieveByuserName">
        <el-button slot="append" icon="el-icon-search" @click="getrewardAchieveByuserName" />
      </el-input>
      <!-- 根据获奖名搜索 -->
      <el-input v-model="awardedName" style="margin-bottom: 15px;margin-right: 10px;width: 260px; height: 40px;" placeholder="请输入获奖名" clearable @clear="getrewardAchieveByawardedName">
        <el-button slot="append" icon="el-icon-search" @click="getrewardAchieveByawardedName" />
      </el-input>
      <!-- 导出信息 -->
      <download-excel :data="rewardAchieveList" :fields="excelFields" style="display: inline;">
        <el-button v-preventReClick="3000" type="primary" style="float: right;margin-bottom: 15px;" icon="el-icon-download">导出信息</el-button>
      </download-excel>
      <!-- 渲染获奖信息 -->
      <el-table
        :data="rewardAchieveList"
        :default-sort="{prop: 'awardedTime', order: 'descending'}"
        border
        stripe
      >
        <el-table-column
          type="index"
          label="#"
          align="center"
        />
        <el-table-column
          prop="projectName"
          label="项目名"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="leader"
          :show-overflow-tooltip="true"
          label="负责人"
          align="center"
        />
        <el-table-column
          prop="awardedName"
          :show-overflow-tooltip="true"
          label="获奖名"
          align="center"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="awardedTime"
          label="获奖时间"
          sortable
          align="center"
        />
        <el-table-column
          prop="issuingDepartment"
          :show-overflow-tooltip="true"
          label="发证机关"
          align="center"
        />
        <el-table-column
          prop="awardedNumber"
          :show-overflow-tooltip="true"
          label="获奖编号"
          align="center"
        />
        <el-table-column
          prop="grade"
          :show-overflow-tooltip="true"
          label="项目等级"
          align="center"
        />
        <el-table-column
          prop="departmentId"
          :show-overflow-tooltip="true"
          label="成果所属单位"
          align="center"
        />
      </el-table>
      <!-- 分页 -->
      <el-pagination
        style="text-align: right;"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'RewardAchieve',
  data() {
    return {
      // 将表格中的信息导出为Excel的文件头
      excelFields: {
        '项目名': 'projectName',
        '项目负责人': 'leader',
        '获奖名': 'awardedName',
        '获奖时间': 'awardedTime',
        '发证机关': 'issuingDepartment',
        '获奖编号': 'awardedNumber',
        '项目等级': 'grade',
        '成果所属单位': 'departmentId'
      },
      rewardAchieveList: [],
      currentPage: 1,
      pageSize: 5,
      totalNum: 0,
      grade: ['校级', '省级', '国家级'],
      departmentList: [],
      userName: '',
      awardedName: ''
    }
  },
  created() {
    // 获取缓存中的部门列表信息
    this.departmentList = JSON.parse(this.$store.getters.getdepartment)
    // console.log('this.departmentList', this.departmentList)
    this.init()
    // this.getdepartmentList()
  },
  methods: {
    /**
     * @description: 将初始化获取到的信息转化为要展示的对象数组
     * @param {*} res
     * @return {*}
     * @author: Hongting Yuan
     */
    getList(res) {
      var self = this
      for (var i = 0; i < res.data.data.list.length; i++) {
        // if (res.data.data.list[i].examineStatus !== '审核通过') {
        //   continue
        // }
        const objectResult = {}
        objectResult.projectName = res.data.data.list[i].projectExamineVo.projectName
        objectResult.leader = res.data.data.list[i].leaderName
        if (objectResult.leader === null) {
          for (var j = 0; j < res.data.data.list[i].projectExamineVo.team.length; j++) {
            if (res.data.data.list[i].projectExamineVo.team[j].userId === res.data.data.list[i].leaderId) {
              objectResult.leader = res.data.data.list[i].projectExamineVo.team[j].userRealname
            }
          }
        }
        objectResult.awardedName = res.data.data.list[i].awardedName
        objectResult.awardedTime = self.getdata(res.data.data.list[i].awardedTime)
        objectResult.issuingDepartment = res.data.data.list[i].issuingDepartment
        objectResult.grade = self.grade[res.data.data.list[i].projectExamineVo.levelId - 1]
        objectResult.awardedNumber = res.data.data.list[i].awardedNumber
        objectResult.departmentId = self.departmentList[res.data.data.list[i].departmentId].name
        objectResult.examineStatus = res.data.data.list[i].examineStatus
        self.rewardAchieveList.push(objectResult)
      }
      // self.totalNum = self.rewardAchieveList.length
      self.totalNum = res.data.data.total
    },
    /**
     * @description: 获取获奖成果信息，初始化获奖成果数据
     * @param {*}
     * @return {*}
     * @author: Hongting Yuan
     */
    init() {
      var self = this
      axios.get(`/achievement/searchAllPass/awarded?pageNum=${self.currentPage}&pageSize=${self.pageSize}`)
        .then(res => {
          if (res.data.code !== 200) return this.$message.error('获取获奖列表失败')
          // console.log(res)
          self.rewardAchieveList = []
          if (res.data.data && res.data.data.list) {
            self.getList(res)
          } else {
            self.totalNum = 0
          }
          // console.log(this.rewardAchieveList)
        })
        .catch(err => {
          console.error(err)
        })
    },
    /**
     * @description: 根据获奖项目负责人姓名搜索获奖成果
     * @param {*}
     * @return {*}
     * @author: Hongting Yuan
     */
    getrewardAchieveByuserName() {
      var self = this
      if (self.userName === '') {
        self.init()
      } else {
        axios.get('/achievement/seaUserName/awarded', { params: { userName: self.userName }})
          .then(res => {
            if (res.data.code !== 200) return this.$message.error('搜索获奖信息失败')
            self.rewardAchieveList = []
            if (res.data.data && res.data.data.list) {
              self.getList(res)
            } else {
              self.totalNum = 0
            }
            // console.log('rewardAchieveList', this.rewardAchieveList)
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    /**
     * @description: 根据获奖名搜索获奖成果
     * @param {*}
     * @return {*}
     * @author: Hongting Yuan
     */
    getrewardAchieveByawardedName() {
      var self = this
      if (self.awardedName === '') {
        self.init()
      } else {
        axios.get('/achievement/searchByName/awarded', { params: { achievementName: self.awardedName }})
          .then(res => {
            if (res.data.code !== 200) return this.$message.error('搜索获奖信息失败')
            self.rewardAchieveList = []
            if (res.data.data && res.data.data.list) {
              self.getList(res)
            } else {
              self.totalNum = 0
            }
            // console.log(this.rewardAchieveList)
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    /**
     * @description: 将时间戳转为2021-11-07 21:31:13格式
     * @param {*} data
     * @return {*}
     * @author: Hongting Yuan
     */
    getdata(data) {
      var date = new Date(data)
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
      return Y + M + D
    },
    // 获取部门列表
    // getdepartmentList() {
    //   axios.get('/dictionary/searchAll/department')
    //     .then(res => {
    //       if (res.data.code !== 200) return this.$message.error('获取部门列表失败')
    //       this.departmentList = res.data.data
    //       console.log(this.departmentList)
    //       this.init()
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    /**
     * @description: 页面展示数据条数发生变化
     * @param {*} val
     * @return {*}
     * @author: Hongting Yuan
     */
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    /**
     * @description: 当前显示页发生变化
     * @param {*} val
     * @return {*}
     * @author: Hongting Yuan
     */
    handleCurrentChange(val) {
      this.currentPage = val
      this.init()
    }
  }
}
</script>
<style lang="less">
  .selectAuthor{
    padding-top: 20px;
    text-align: center;
  }
  .el-table-column{
    text-align: center;
  }
</style>
